import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { FollowButton } from '@sorare/core/src/components/user/FollowButton';

import { UserNetworkInfo } from './UserNetworkInfo';
import { UserNetwork_user } from './__generated__/index.graphql';

type Props = {
  user: UserNetwork_user & { subscriptionSlug?: string };
};

const Wrapper = styled(Vertical).attrs({ gap: 2 })`
  position: relative;
  text-transform: capitalize;
  padding: var(--double-unit);
  border-bottom: 1px solid rgba(var(--c-rgb-black), 0.25);
  background: var(--c-nd-50);
  border-radius: var(--double-unit);
  color: var(--c-white);
  justify-content: space-between;
  overflow: hidden;
  isolation: isolate;
`;

const StyledFollowButton = styled(FollowButton)`
  isolation: isolate;
`;

export const UserNetwork = ({ user }: Props) => {
  return (
    <Wrapper>
      <UserNetworkInfo user={user} />
      <StyledFollowButton
        size="small"
        subscribable={{ slug: user.slug, __typename: 'User' }}
        initialSubscription={user.followed}
      />
    </Wrapper>
  );
};

UserNetwork.fragments = {
  user: gql`
    fragment UserNetwork_user on PublicUserInfoInterface {
      slug
      followed {
        slug
      }
      ...UserNetworkInfo_publicUserInfoInterface
    }
    ${UserNetworkInfo.fragments.user}
  ` as TypedDocumentNode<UserNetwork_user>,
};
